<template>
  <div class="creative-group-wrap">
    <div v-show="adCount.length > 0">
      <div class="card-header">
        创意组<span class="num-text">{{ dataList.length }}/10</span>
        <span class="nodata-tip" v-if="showNoDataTip">请完善创意组数据</span>
        <div class="btn-group">
          <el-button icon="el-icon-plus" type="text" :disabled="adCount.length === 0" @click="newCreative">新增</el-button
          ><span class="center-line"></span>

          <el-dropdown @command="(key) => showMaterialModal(true, key)">
            <el-button icon="el-icon-plus" type="text">批量新增</el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="video" :disabled="adCount.length === 0">批量添加视频素材</el-dropdown-item>
              <el-dropdown-item command="image" :disabled="adCount.length === 0">批量添加图片素材</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <span class="center-line"></span>
          <el-button @click="clearAllGroup" type="text" :disabled="adCount.length === 0">清空</el-button>
        </div>
      </div>
      <div v-if="dataList.length > 0">
        <div class="card-list">
          <card-item
            v-for="item of dataList"
            :key="item.itemId"
            :title="item.groupName"
            :dataSet="item"
            @edit="editCreativeGroup"
            @copy="copyCreativeGroup"
            @del="delCreativeGroup"
            :isCur="curItem.itemId === item.itemId"
            :showDelete="true"
          ></card-item>
        </div>
        <div class="modal-body" v-loading="loading">
          <ul class="modal-form">
            <el-form ref="modelRef" :model="this" :rules="rules">
              <li class="form-item" style="margin-bottom: 0px">
                <span class="form-label" style="padding-top: 10px">创意组名称：</span>
                <div class="form-value">
                  <el-form-item prop="creativeGroupName">
                    <el-input v-model="creativeGroupName" placeholder="请填写" style="width: 225px" @input="changeGroupName"></el-input>
                  </el-form-item>
                </div>
              </li>
              <li class="form-item">
                <span class="form-label" style="padding-top: 4px">投放素材：</span>
                <div class="form-value">
                  <div class="upload-header">
                    <el-form-item prop="curMaterialType" v-if="!isDynamicCreative">
                      <el-radio-group v-model="curMaterialType">
                        <el-radio label="video">视频({{ videoList.length }}/10)</el-radio>
                        <el-radio label="image">图片({{ imageList.length }}/12)</el-radio>
                      </el-radio-group>
                    </el-form-item>
                    <el-form-item prop="curMaterialType" v-else>
                      <el-select
                        v-model="curMaterialFileMode"
                        :disabled="isDynamicCreative && (videoList.length > 0 || imageList.length > 0 || combineImageList.length > 0)"
                      >
                        <div v-if="isWxChatMoments">
                          <el-option value="CREATIVE_IMAGE_MODE_VIDEO" label="卡片视频"> </el-option>
                          <el-option value="CREATIVE_IMAGE_MODE_VIDEO_VERTICAL" label="竖版视频"> </el-option>
                          <el-option value="CREATIVE_IMAGE_MODE_LARGE" label="卡片大图"> </el-option>
                          <el-option value="CREATIVE_IMAGE_MODE_LARGE_VERTICAL" label="常规大图"> </el-option>
                          <el-option value="CREATIVE_IMAGE_COMBINE" label="组图"> </el-option>
                        </div>
                        <div v-else>
                          <el-option value="CREATIVE_IMAGE_MODE_LARGE" label="横板大图"> </el-option>
                          <el-option v-if="!isQQShop" value="CREATIVE_IMAGE_MODE_LARGE_VERTICAL" label="竖版大图"> </el-option>
                          <el-option value="CREATIVE_IMAGE_MODE_VIDEO" label="横版视频"> </el-option>
                          <el-option value="CREATIVE_IMAGE_MODE_VIDEO_VERTICAL" label="竖版视频"> </el-option>
                        </div>
                      </el-select>
                      <div v-if="!isCreativeImageCombine" style="display: inline-block;">
                        <span style="margin-left: 8px;color: #86909c;" v-if="videoList.length > 0">视频({{ videoList.length }}/10)</span>
                        <span style="margin-left: 8px;color: #86909c;" v-if="imageList.length > 0">图片({{ imageList.length }}/12)</span>
                      </div>
                    </el-form-item>
                    <el-button
                      v-if="!isCreativeImageCombine"
                      class="add-btn"
                      type="text"
                      icon="el-icon-plus"
                      @click="showMaterialModal(false)"
                      :disabled="
                        (curMaterialType === 'video' && videoList.length >= 10) || (curMaterialType === 'image' && imageList.length >= 12)
                      "
                      >添加素材
                    </el-button>
                  </div>
                  <div class="upload-wrap" v-if="!isCreativeImageCombine">
                    <div class="content-wrap video-wrap" v-show="curMaterialType === 'video'">
                      <div class="video-item" v-for="item of videoList" :key="item.uuid">
                        <div class="video-slide">
                          <div class="video-header">视频:</div>
                          <div class="video-content">
                            <video controls="controls" class="material" :src="item.path"></video>
                          </div>
                        </div>
                        <div class="video-slide">
                          <div class="video-header">封面:</div>
                          <div class="video-content">
                            <img class="material" :src="item.coverPath" />
                          </div>
                        </div>
                        <span class="close-btn" @click="deleteItem(item.uuid)"><i class="el-icon-close"></i></span>
                      </div>
                    </div>
                    <div class="content-wrap image-wrap" v-show="curMaterialType === 'image'">
                      <div class="img-item" v-for="item of imageList" :key="item.uuid">
                        <img class="img" :src="item.path" />
                        <span class="close-btn" @click="deleteItem(item.uuid)"><i class="el-icon-close"></i></span>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <!-- 微信朋友圈版位 -->
              <li class="form-item" v-if="(isWxChatMoments && !isDynamicCreative) || isCreativeImageCombine">
                <span class="form-label" style="padding-top: 4px">组图：</span>
                <div class="form-value">
                  <el-button style="margin: -7px 0;" type="text" icon="el-icon-plus" @click="showMaterialModal(false, '', true)"
                    >添加素材
                  </el-button>
                  <el-form-item prop="creativeGroupName">
                    <span class="form-label" style="padding-top: 4px;width: 80px">组图数量：</span>
                    <el-radio-group v-model="combineImageCount" size="small" @change="changeCombineImageCount">
                      <el-radio-button :label="3">3</el-radio-button>
                      <el-radio-button :label="4">4</el-radio-button>
                      <el-radio-button :label="6">6</el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item prop="creativeGroupName">
                    <span class="form-label" style="padding-top: 4px;width: 80px">组图方式：</span>
                    <el-radio-group v-model="combineType" size="small" @change="confirmSelect">
                      <el-radio-button :label="1">常规</el-radio-button>
                      <el-radio-button :label="2">随机</el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item prop="combineImageList">
                    <div class="upload-wrap">
                      <div class="content-wrap image-wrap">
                        <div class="img-item" v-for="item of combineImageList" :key="item.uuid">
                          <img class="img" :src="item.path" />
                          <span class="close-btn" @click="deleteItem(item.uuid, true)"><i class="el-icon-close"></i></span>
                        </div>
                      </div>
                    </div>
                  </el-form-item>
                </div>
              </li>
            </el-form>
          </ul>
        </div>
      </div>
    </div>
    <div v-show="adCount.length === 0 || dataList.length === 0">
      <div class="card-header" v-if="adCount.length === 0">
        创意组
      </div>
      <div class="empty-content">
        {{ dataList.length === 0 ? "暂无数据" : "请选择账户" }}
      </div>
    </div>

    <!-- 素材选择弹框 -->
    <material-modal
      ref="materialModalRef"
      @selectOk="selectedMaterial"
      :selectType="isCombined ? 'image' : curMaterialType"
      :showGroupNum="showGroupNum"
      :fileMode="fileMode"
    ></material-modal>

    <!-- 选择已有创意组 -->
    <checked-modal
      title="选择创意组"
      :tableConf="tableConf"
      :tableData="tableData"
      ref="checkedModalRef"
      @selectOk="selectOk"
    ></checked-modal>
  </div>
</template>

<script>
import MaterialModal from "./subBaseset/sub/materialModal.vue";
import CheckedModal from "./common/checkedModal.vue";
import { getMaterialsInfo } from "@/api/promotion-gdt.js";
import { mapState } from "vuex";
import CardItem from "./common/cardItem.vue";
import { combineImageTypeList } from "../subPlan/common/config";
export default {
  components: {
    MaterialModal,
    CardItem,
    CheckedModal,
  },
  data() {
    return {
      combineImageTypeList,
      tableConf: [
        { title: "创意组名称", colName: "groupName" },
        { title: "创建日期", colName: "createTimeStr" },
      ],
      tableData: [],
      dataList: [],
      curItem: {}, //当前编辑对象
      creativeGroupName: "",
      curMaterialType: "video",
      curMaterialFileMode: "CREATIVE_IMAGE_MODE_VIDEO",
      videoList: [],
      imageList: [],
      isCombined: false, // 当前操作是否为选择组图
      combineImageList: [],
      combineImageCount: 3,
      combineType: 1,
      loading: false,
      rules: {
        creativeGroupName: [{ required: true, message: "创意组名称必填", trigger: "blur" }],
        curMaterialType: [
          {
            trigger: "change",
            validator: (rule, value, callback) => {
              if (this.videoList.length + this.imageList.length + this.combineImageList.length === 0 && !this.isCreativeImageCombine) {
                callback(new Error("请上传视频或图片素材"));
              } else {
                callback();
              }
            },
          },
        ],
        combineImageList: [
          {
            trigger: "change",
            validator: (rule, value, callback) => {
              if (this.videoList.length + this.imageList.length + this.combineImageList.length === 0) {
                callback(new Error("请上传组图素材"));
              } else if (this.videoList.length + this.imageList.length === 0 && this.combineImageList.length !== this.combineImageCount) {
                callback(new Error("组图数量缺失，请补充完整组图"));
              } else {
                callback();
              }
            },
          },
        ],
      },
      showGroupNum: false, //是否批量添加创意组
      showNoDataTip: false,
      groupLength: 1,
    };
  },
  mounted() {
    this.newCreative();
  },
  methods: {
    newCreative() {
      if (this.dataList.length >= 10) {
        return;
      }
      let newItem = {
        itemId: Math.random(),
        groupName: "新建创意组" + this.groupLength,
        creativeMaterials: [],
        combineImageCount: 3,
        curMaterialFileMode: "",
        combineType: 1,
      };
      this.groupLength += 1;
      this.dataList.push(newItem);
      this.saveInStore();
    },
    editCreativeGroup(dataItem) {
      this.curItem.groupName = this.creativeGroupName; //切换时保存当前的
      this.showEditModal(dataItem);
      this.$nextTick(() => {
        this.$refs.modelRef.validate(() => {});
      });
    },
    copyCreativeGroup(dataItem) {
      if (this.dataList.length >= 10) {
        return;
      }
      let copyData = JSON.parse(JSON.stringify(dataItem));
      this.dataList.push({
        itemId: Math.random(),
        groupName: copyData.groupName + "_复制",
        creativeMaterials: copyData.creativeMaterials,
        combineImageCount: copyData.combineImageCount,
        curMaterialFileMode: copyData.curMaterialFileMode,
        combineType: copyData.combineType,
      });
      this.saveInStore();
    },
    delCreativeGroup(dataItem) {
      let delIndex = this.dataList.findIndex((item) => item.itemId === dataItem.itemId);
      this.dataList.splice(delIndex, 1);
      this.saveInStore();
    },
    clearAllGroup() {
      this.dataList = [];
      this.saveInStore();
    },
    changeCombineImageCount() {
      this.combineImageList = [];
      this.confirmSelect(); //删除完成后进行保存
      this.$nextTick(() => {
        this.$refs.modelRef.validate(() => {});
      });
    },
    /**
     * flag: 素材组件内部是否展示分组信息
     * type: 素材组件展示的素材类型
     */
    showMaterialModal(flag, type, isCombined = false) {
      this.showGroupNum = flag;
      type && (this.curMaterialType = type);
      this.isCombined = isCombined;
      this.$nextTick(() => {
        this.$refs.materialModalRef.showModal();
      });
    },
    selectedMaterial(resData) {
      let { mapList, groupNum } = resData;
      if (groupNum) {
        // 批量添加
        this.fillAndSaveGroupData(mapList, groupNum);
      } else {
        // 添加素材
        this.fillAndSaveCurData(mapList);
      }
    },
    //分组保存数据
    fillAndSaveGroupData: async function(mapList, groupNum) {
      let videoList = [];
      let imageList = [];
      if (this.curMaterialType === "video") {
        for (let dataItem of Object.values(mapList)) {
          videoList.push({
            uuid: dataItem.uuid,
            path: dataItem.path,
            coverPath: dataItem.coverPath,
            id: dataItem.id,
          });
        }
      } else {
        for (let dataItem of Object.values(mapList)) {
          imageList.push({
            uuid: dataItem.uuid,
            path: dataItem.path,
            id: dataItem.id,
          });
        }
      }

      let gdtList = await this.formatData(videoList.concat(imageList));
      this.setGroupData(gdtList.creativeMaterials, Number(groupNum), gdtList);
    },
    //赋值组数据
    setGroupData(allList, groupNum, gdtList) {
      //数据分组
      let creativeGroup = [];
      if (allList[0].image_ids) {
        //图片素材
        let subIdList = [];
        let subUrlList = [];
        let subUUIDList = [];
        allList[0].image_ids.forEach((item, index) => {
          subIdList.push(allList[0].image_ids[index]);
          subUrlList.push(allList[0].image_urls[index]);
          subUUIDList.push(allList[0].image_uuids[index]);
          if ((index + 1) % groupNum === 0) {
            creativeGroup.push([
              {
                image_ids: subIdList,
                image_urls: subUrlList,
                image_uuids: subUUIDList,
              },
            ]);
            subIdList = [];
            subUrlList = [];
            subUUIDList = [];
          }
        });
        if (subIdList.length > 0) {
          creativeGroup.push([
            {
              image_ids: subIdList,
              image_urls: subUrlList,
              image_uuids: subUUIDList,
            },
          ]);
        }
      } else {
        //视频素材
        let subList = [];
        allList.forEach((item, index) => {
          subList.push(item);
          if ((index + 1) % groupNum === 0) {
            creativeGroup.push(subList);
            subList = [];
          }
        });
        if (subList.length > 0) {
          creativeGroup.push(subList);
        }
      }

      //通过分组数据创建创意组
      this.dataList = this.dataList.filter((item) => item.creativeMaterials.length > 0); //去除已有的空数据

      creativeGroup.forEach((cerativesList) => {
        if (this.dataList.length < 10) {
          this.dataList.push({
            itemId: Math.random(),
            groupName: "新建创意组" + (this.dataList.length + 1),
            creativeMaterials: cerativesList,
            combineImageCount: gdtList.combineImageCount,
            curMaterialFileMode: gdtList.curMaterialFileMode,
            combineType: gdtList.combineType,
          });
        }
      });
      this.saveInStore();
    },
    fillAndSaveCurData(dataList) {
      if (this.isCombined) {
        for (let dataItem of Object.values(dataList)) {
          if (!this.combineImageList.map((item) => item.uuid).includes(dataItem.uuid)) {
            this.combineImageList.push({
              uuid: dataItem.uuid,
              path: dataItem.path,
              id: dataItem.id,
            });
          }
        }
      } else {
        if (this.curMaterialType === "video") {
          for (let dataItem of Object.values(dataList)) {
            if (!this.videoList.map((item) => item.uuid).includes(dataItem.uuid)) {
              if (this.videoList.length < 10) {
                this.videoList.push({
                  uuid: dataItem.uuid,
                  path: dataItem.path,
                  coverPath: dataItem.coverPath,
                  id: dataItem.id,
                });
              } else {
                this.$message({
                  message: "视频数量超出限制",
                  type: "warning",
                });
                break;
              }
            }
          }
        } else {
          for (let dataItem of Object.values(dataList)) {
            if (!this.imageList.map((item) => item.uuid).includes(dataItem.uuid)) {
              if (this.imageList.length < 12) {
                this.imageList.push({
                  uuid: dataItem.uuid,
                  path: dataItem.path,
                  id: dataItem.id,
                });
              } else {
                this.$message({
                  message: "图片数量超出限制",
                  type: "warning",
                });
                break;
              }
            }
          }
        }
      }
      this.confirmSelect(); //选择完成后就进行保存
    },
    deleteItem(uuid, isCombined = false) {
      if (isCombined) {
        let delIndex = this.combineImageList.findIndex((item) => item.uuid === uuid);
        this.combineImageList.splice(delIndex, 1);
      } else {
        if (this.curMaterialType === "video") {
          let delIndex = this.videoList.findIndex((item) => item.uuid === uuid);
          this.videoList.splice(delIndex, 1);
        } else {
          let delIndex = this.imageList.findIndex((item) => item.uuid === uuid);
          this.imageList.splice(delIndex, 1);
        }
      }

      this.confirmSelect(); //删除完成后进行保存
      this.$nextTick(() => {
        this.$refs.modelRef.validate(() => {});
      });
    },
    //分组时不是格式化的当前list, 而是格式化外部传来的数据
    formatData(groupList) {
      return new Promise((resolve) => {
        let contentArr = groupList || this.videoList.concat(this.imageList, this.combineImageList);
        if (
          (this.curMaterialType === "video" && this.videoList.length > 0) ||
          (this.curMaterialType === "image" && this.imageList.length > 0) ||
          this.combineImageList.length > 0
        ) {
          this.loading = true;
          getMaterialsInfo({
            accountId: this.adCount[0].advertiserId,
            fileIds: contentArr.map((item) => item.id),
          }).then((res) => {
            this.loading = false;
            if (res.code === "0000") {
              let gdtArr = res.data;
              let videoArr = [];
              let imageArr = [];
              gdtArr.forEach((item) => {
                if (item.videoId || item.imageId) {
                  const findObj = this.combineImageTypeList.find((item) => item.key === this.curMaterialFileMode) || {};
                  const adTemplateId = this.isWxChatMoments ? findObj.value : "";
                  if (item.type === "video") {
                    videoArr.push({
                      videoId: item.videoId,
                      imageId: item.imageId, //视频封面
                      type: "VIDEO",
                      fileMode: item.fileMode || null,
                      name: item.name,
                      //回显需要
                      uuid: item.uuid,
                      id: item.fileId,
                      imageUrl: item.imageUrl,
                      videoUrl: item.videoUrl,
                      adTemplateId,
                    });
                  } else {
                    imageArr.push({
                      imageId: item.imageId,
                      type: item.fileMode === "CREATIVE_IMAGE_COMBINE" ? "COMBINE_IMAGE" : "IMAGE",
                      fileMode: item.fileMode || null,
                      name: item.name,
                      //回显需要
                      uuid: item.uuid,
                      id: item.fileId,
                      imageUrl: item.imageUrl,
                      adTemplateId:
                        item.fileMode === "CREATIVE_IMAGE_COMBINE"
                          ? this.combineImageTypeList.find((item) => item.num === this.combineImageCount).value
                          : adTemplateId,
                    });
                  }
                } else {
                  this.$message.error("部分素材获取ID失败");
                }
              });

              let saveData = {
                groupName: this.creativeGroupName,
                creativeMaterials: videoArr.concat(imageArr),
                combineImageCount: this.combineImageCount,
                combineType: this.combineType,
                curMaterialFileMode: this.curMaterialFileMode,
              };
              resolve(saveData);
            }
          });
        } else {
          resolve({
            groupName: this.creativeGroupName,
            creativeMaterials: [],
            combineImageCount: this.combineImageCount,
            curMaterialFileMode: this.curMaterialFileMode,
            combineType: this.combineType,
          });
        }
      });
    },
    //编辑数据弹框
    showEditModal(dataItem) {
      this.curItem = dataItem; //接口数据格式
      this.videoList = [];
      this.imageList = [];
      this.combineImageList = [];
      this.creativeGroupName = dataItem.groupName;
      this.combineImageCount = dataItem.combineImageCount;
      this.curMaterialFileMode = dataItem.curMaterialFileMode;
      this.combineType = dataItem.combineType;
      if (dataItem.creativeMaterials.length > 0) {
        dataItem.creativeMaterials.forEach((creative) => {
          if (creative.videoId) {
            //视频素材
            this.videoList.push({
              id: creative.id,
              uuid: creative.uuid,
              path: creative.videoUrl,
              coverPath: creative.imageUrl,
            });
          } else {
            if (creative.fileMode === "CREATIVE_IMAGE_COMBINE") {
              //图片素材
              this.combineImageList.push({
                id: creative.id,
                uuid: creative.uuid,
                path: creative.imageUrl,
              });
            } else {
              //图片素材
              this.imageList.push({
                id: creative.id,
                uuid: creative.uuid,
                path: creative.imageUrl,
              });
            }
          }
        });
      }
    },
    confirmSelect: async function() {
      let saveData = await this.formatData();
      this.curItem.groupName = saveData.groupName;
      this.curItem.creativeMaterials = saveData.creativeMaterials;
      this.curItem.combineImageCount = saveData.combineImageCount;
      this.curItem.curMaterialFileMode = saveData.curMaterialFileMode;
      this.curItem.combineType = saveData.combineType;
      this.saveInStore();
      this.$nextTick(() => {
        this.$refs.modelRef.validate(() => {});
      });
    },
    saveInStore() {
      let copyData = JSON.parse(JSON.stringify(this.dataList));
      let storeData = copyData.map((item) => {
        return {
          itemId: item.itemId,
          groupName: item.groupName,
          combineImageCount: item.combineImageCount,
          combineType: item.combineType,
          creativeMaterials: item.creativeMaterials,
          curMaterialFileMode: item.curMaterialFileMode,
        };
      });
      this.$store.commit("set_draft_creative_gdt", storeData);
    },
    selectOk(dataList) {
      dataList.forEach((item) => {
        let groupItem = JSON.parse(item.creative_item);
        this.dataList.push({
          itemId: Math.random(),
          combineImageCount: groupItem.combineImageCount,
          curMaterialFileMode: groupItem.curMaterialFileMode,
          combineType: groupItem.combineType,
          groupName: groupItem.groupName,
          creativeMaterials: groupItem.creativeMaterials,
        });
      });
      this.saveInStore();
    },
    //检查并且保存最终数据（创意组数据已经实时同步到store，无需再次保存,只用检查必填项）
    checkData() {
      return new Promise((resolve, reject) => {
        if (this.dataList.length > 0) {
          this.showNoDataTip = false;
          let pass = true;
          for (let i = 0; i < this.dataList.length; i++) {
            let item = this.dataList[i];
            if (item.groupName === "" || item.creativeMaterials.length === 0) {
              pass = false;
              this.showEditModal(item);
              this.$nextTick(() => {
                this.$refs.modelRef.validate(() => {});
              });
              break;
            }
          }
          if (pass) {
            resolve();
          } else {
            reject();
          }
        } else {
          this.showNoDataTip = true;
          reject();
        }
      });
    },
    //修改创意组实时更新到store
    changeGroupName(name) {
      this.saveInStore();
      this.$nextTick(() => {
        this.$store.commit("set_creative_groupName_gdt", {
          id: this.curItem.itemId,
          name: name,
        });
        this.dataList = this.creativeGroups;
      });
    },
  },
  computed: {
    ...mapState({
      adCount: (state) => state.PromotionGdt.adCount || [],
      draftAdset: (state) => state.PromotionGdt.draft_adset,
      isDynamicCreative: (state) => state.PromotionGdt.draft_adset.isDynamicCreative,
      originCreativeGroups: (state) => state.PromotionGdt.origin_draft_creative.creativeGroups,
      creativeGroups: (state) => state.PromotionGdt.draft_creative.creativeGroups,
    }),
    fileMode() {
      let mode = "";
      if (this.isDynamicCreative) {
        mode = this.curMaterialFileMode;
      } else {
        if (this.isWxChatMoments && this.curMaterialType === "image") {
          mode = this.isCombined ? "CREATIVE_IMAGE_COMBINE" : "CREATIVE_IMAGE_MODE_LARGE,CREATIVE_IMAGE_COMBINE";
        } else if (this.isQQShop) {
          mode =
            this.curMaterialType === "image" ? "CREATIVE_IMAGE_MODE_LARGE" : "CREATIVE_IMAGE_MODE_VIDEO,CREATIVE_IMAGE_MODE_VIDEO_VERTICAL";
        } else {
          mode = this.isCombined
            ? "CREATIVE_IMAGE_COMBINE"
            : "CREATIVE_IMAGE_MODE_LARGE,CREATIVE_IMAGE_MODE_LARGE_VERTICAL,CREATIVE_IMAGE_MODE_VIDEO,CREATIVE_IMAGE_MODE_VIDEO_VERTICAL";
        }
      }
      return mode;
    },
    isWxChatMoments() {
      return (
        this.draftAdset.placement &&
        this.draftAdset.placement.siteSet?.length === 1 &&
        this.draftAdset.placement.siteSet[0] === "SITE_SET_MOMENTS"
      );
    },
    isQQShop() {
      return (
        this.draftAdset.placement &&
        this.draftAdset.placement.siteSet?.length === 1 &&
        this.draftAdset.placement.siteSet[0] === "SITE_SET_QQSHOPPING"
      );
    },
    isCreativeImageCombine() {
      return this.isDynamicCreative && this.isWxChatMoments && this.curMaterialFileMode === "CREATIVE_IMAGE_COMBINE";
    },
  },
  watch: {
    dataList: {
      handler(value) {
        if (value) {
          if (value.length > 0) {
            let curId = this.curItem.itemId;
            let curItem = value.find((item) => item.itemId === curId);
            if (curItem) {
              this.showEditModal(curItem);
            } else {
              this.showEditModal(value[value.length - 1]);
            }
          }
        }
      },
    },
    curMaterialFileMode: {
      handler(val) {
        if (val) {
          this.curMaterialType = ["CREATIVE_IMAGE_MODE_VIDEO", "CREATIVE_IMAGE_MODE_VIDEO_VERTICAL"].includes(val) ? "video" : "image";
        }
      },
      immediate: true,
    },
    isDynamicCreative: {
      handler() {
        this.videoList = [];
        this.imageList = [];
        this.dataList = [];
        this.curItem = {};
        this.newCreative();
      },
    },
    originCreativeGroups: {
      handler(value) {
        if (value) {
          const storeData = JSON.parse(JSON.stringify(value));
          this.dataList = storeData.map((item) => {
            return {
              itemId: item.itemId,
              groupName: item.groupName,
              creativeMaterials: item.creativeMaterials,
              combineImageCount: item.combineImageCount,
              combineType: item.combineType,
              curMaterialFileMode: item.curMaterialFileMode,
            };
          });
          this.groupLength = this.dataList.length + 1;
          //聚焦最后一个
          if (this.dataList.length > 0) {
            let curId = this.curItem.itemId;
            let curItem = this.dataList.find((item) => item.itemId === curId);
            if (curItem) {
              this.showEditModal(curItem);
            } else {
              this.showEditModal(this.dataList[this.dataList.length - 1]);
            }
          }
          this.saveInStore();
        }
      },
    },
  },
};
</script>

<style lang="less" scoped>
.creative-group-wrap {
  padding: 24px;
  margin-top: 16px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
  .card-header {
    color: rgba(0, 0, 0, 1);
    font-size: 16px;
    font-weight: bold;
    display: flex;
    align-items: center;
    .num-text {
      color: rgba(0, 0, 0, 0.85);
      font-size: 14px;
      font-weight: normal;
      margin-left: 12px;
      position: relative;
      top: 2px;
    }
    .nodata-tip {
      color: #f56c6c;
      font-size: 12px;
      position: relative;
      left: 10px;
      top: 1px;
    }
  }
  .empty-content {
    height: 200px;
    font-size: 20px;
    margin-left: 10px;
    color: #818181;
    text-align: center;
    line-height: 200px;
  }
  .btn-group {
    margin-left: auto;
    .center-line {
      border-left: 1px solid rgba(0, 0, 0, 0.25);
      margin: 0 20px;
    }
  }
  .card-list {
    display: flex;
    flex-wrap: wrap;
    padding-top: 16px;
  }
  .modal-body {
    .modal-form {
      margin: 0px;
      padding: 0px;
      list-style: none;
      .form-item {
        display: flex;
        margin-bottom: 16px;
        .form-label {
          flex-shrink: 0;
          display: inline-block;
          width: 85px;
          text-align: right;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.65);
        }
        .form-value {
          width: 100%;
          padding-top: 2px;
          /deep/ .el-radio__input.is-checked .el-radio__inner {
            color: rgba(24, 144, 255, 1);
            border-color: rgba(24, 144, 255, 1);
            background: rgba(24, 144, 255, 1);
          }
          /deep/ .el-radio__input.is-checked + .el-radio__label {
            color: rgba(24, 144, 255, 1);
          }
          .upload-header {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            /deep/ .el-form-item__content {
              line-height: 25px;
            }
            .add-btn {
              padding: 0px;
              margin: 0px;
            }
          }
          .upload-wrap {
            margin-top: 10px;
            border-radius: 2px;
            background: rgba(244, 244, 244, 1);
            padding: 8px 0px 16px 16px;
            .content-wrap {
              height: 300px;
              overflow: auto;
              display: flex;
              flex-wrap: wrap;
              &::-webkit-scrollbar {
                display: none;
                width: 0 !important;
                height: 0 !important;
                background: transparent;
              }
              &.video-wrap {
                .video-item {
                  padding: 9px 0px 9px 9px;
                  height: 176px;
                  border-radius: 4px;
                  border: 1px solid rgba(0, 0, 0, 0.11);
                  box-sizing: border-box;
                  background: rgba(255, 255, 255, 1);
                  display: flex;
                  position: relative;
                  margin: 8px 12px 0px 0px;

                  .video-slide {
                    width: 108px;
                    margin-right: 9px;
                    .video-header {
                      color: rgba(0, 0, 0, 0.65);
                      font-size: 14px;
                      padding: 4px 0;
                    }
                    .video-content {
                      display: inline-block;
                      width: 108px;
                      height: 130px;
                      background-color: #eee;
                      .material {
                        width: 100%;
                        height: 100%;
                        object-fit: contain;
                      }
                    }
                  }
                  .close-btn {
                    position: absolute;
                    right: -8px;
                    top: -8px;
                    display: inline-block;
                    width: 14px;
                    height: 14px;
                    border-radius: 50%;
                    background: rgba(214, 214, 214, 1);
                    text-align: center;
                    line-height: 14px;
                    cursor: pointer;
                    font-size: 12px;
                  }
                }
              }
              &.image-wrap {
                .img-item {
                  height: 176px;
                  width: 240px;
                  padding: 9px;
                  border-radius: 4px;
                  border: 1px solid rgba(0, 0, 0, 0.11);
                  box-sizing: border-box;
                  background: rgba(255, 255, 255, 1);
                  position: relative;
                  margin: 8px 16px 8px 0px;
                  .img {
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                  }
                  .close-btn {
                    position: absolute;
                    right: -8px;
                    top: -8px;
                    display: inline-block;
                    width: 14px;
                    height: 14px;
                    border-radius: 50%;
                    background: rgba(214, 214, 214, 1);
                    text-align: center;
                    line-height: 14px;
                    cursor: pointer;
                    font-size: 12px;
                  }
                }
              }
            }
          }
        }
      }
    }
    .footer-wrap {
      text-align: right;
      display: block;
    }
  }
  .select-count {
    height: 300px;
    font-size: 20px;
    color: #818181;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
